import '../Inscription.less';
import {Popconfirm, Layout, Row, Col,Tabs,ConfigProvider,Table,Modal,Menu,Input, Space, AutoComplete,notification, Select,Form,Button } from 'antd';
import React, { Component } from "react";
import es_ES from 'antd/lib/locale/es_ES';
import Highlighter from 'react-highlight-words';
import {DeleteOutlined, SearchOutlined,CheckOutlined,UserOutlined,EditOutlined,ReadOutlined,DownloadOutlined,MailOutlined, PhoneOutlined, GlobalOutlined, EnvironmentOutlined, IdcardOutlined } from '@ant-design/icons';
import axios from "axios";
import countries from '../static/json/countries.json'
import PhoneInput from 'react-phone-input-2'
import es from 'react-phone-input-2/lang/es.json'
import {getAuthors,getAuthorsStr, getCountryName,IP,getCountryCode  } from '../components/utils';
import Foot from "../components/Footer"
import AdminMenu from "../components/AdminMenu"

class ConcList extends Component {
  constructor(props){
    super(props)
    const { Option } = Select;
    this.state={
      phone: '',
      plays:[],
      edit:false,
      countrychanged:'',
      create:false,
      isBusy:true
    }
  }
  async componentWillMount() {
    //Jury
    const response_jury= await fetch(IP + 'api/musica/jurado/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json_jury = await response_jury.json();
    if(json_jury['detail']){//If not logued,clear storage and show login
      localStorage.clear()
      window.location.reload(); 
    }
    this.names = new Set();
    this.users = new Set();
    var data_jury = []

    for(const i in json_jury){
      const item = json_jury[i];
      this.names.add(item.nombre_completo)
      this.users.add(item.usuario)
        data_jury.push(
            { 
                id : item.id,
                full_name:item.nombre_completo,
                name : item.usuario,
                username_id: item.usuario_id,
                country: getCountryName(item.pais),
                ficha: item.ficha== "undefined" ? "":item.ficha, 
                phone: item.telefono,
                address: item.direcc_personal,
                email: item.email,
                edit:''
            });
    };

    //Plays
    const response_plays= await fetch(IP + 'api/musica/obra/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    
    const json_plays = await response_plays.json();
    var data_play = []
    const Moment = require('moment');
    json_plays.map(play=>
      { 
        var date= new Moment(play.fecha_registro).format('DD-MM-YYYY')
        var year = date.split('-')[2]
        play.author = getAuthors(play.conc)
        play.authorStr = getAuthorsStr(play.conc).join(", ")
        play.countryName= getCountryName(play.conc[0].pais)
        play.date = date 
        play.code=year+'_'+play.genero+'_'+play.id
      })
   
    this.names = [...this.names].map((v)=>{
      return {value:v}
    })
    this.users = [...this.users].map((v)=>{
      return {value:v}
    })
    this.setState({ plays: data_jury, plays_report:data_play,isBusy:false });
  }
  onChangeSelect(value){
    this.setState({countrychanged:value})
  }

  getAutocomplete = (dataIndex) =>{
    if(dataIndex == "full_name"){
      return this.names
    }
    
    else if (dataIndex == "name" ) {
      return this.users
    } 
  }
  onClickJury = record  => {
        this.setState({showArticle:true,record:record});
  };

  async onClickSave(){
    var options = {
       method: "patch",
       credentials: "same-origin",
       headers: {
         "Authorization": localStorage.getItem("Authorization") ,
         "Accept": "application/json",
         "Content-Type": "application/json"},
      
     }
     
    var userChanged = {
      username: document.getElementById("nameInput").value,
      email: document.getElementById("emailInput").value,
    }
    if(document.getElementById("password").value.trim() != "")
      userChanged["password"] = document.getElementById("password").value

    await axios.patch(IP + `api/musica/usuario/${this.state.record.username_id}/`, userChanged, options)
    .then(
      (response) => {
        if(response.status === 200)
           console.log("OK");
         else{
           notification.error({
           message:'Error',
           description:'Hubo un error, por favor revise los datos',
         });
         return
         }
      },
      (error) => {
      
       notification.error({
         message:'Error',
         description:'Hubo un error, por favor revise los datos',
       })
       return
      }
    ).catch((err) =>console.log(err))
    var juryChanged={
      nombre_completo: document.getElementById("fullNameInput").value,
      telefono: document.getElementById("phoneInput").value,
      direcc_personal:document.getElementById("addressInput").value,
      ficha:document.getElementById("fichaInput").value,
      pais:this.state.countrychanged?getCountryCode(this.state.countrychanged):getCountryCode(this.state.record.country),
    }
     
     await axios.patch(IP + `api/musica/jurado/${this.state.record.id}/`, juryChanged, options)
     .then(
       (response) => {
         if(response.status === 200)
            window.location.reload()
          else{
            notification.error({
            message:'Error',
            description:'Hubo un error, por favor revise los datos',
          });
          }
       },
       (error) => {
        notification.error({
          message:'Error',
          description:'Hubo un error, por favor revise los datos',
        })
       }
     ).catch((err) => console.log(err))
   }

  onClickEditJury= record  => {
    this.setState({edit:true,record:record });
  };
  onClickDeleteJury= record  => {
    fetch(IP + `api/musica/jurado/${record.id.toString()}/`,{
      method:'DELETE',
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
     
    }).then(async (res) => {
      if (res.status == 204){
        window.location.reload(false)
      } 
      }).catch((err) => {
        notification.error({
          message:'Error',
          description:"Hubo un error. Intente mas tarde por favor",
        });
    })
  };
  hideModal = () => {
        this.setState({ showArticle: false, record: null});
  };

  hideEdit = () => {
    this.setState({edit: false,record: null});
  };
getColumnPlaysSearchProps = (dataIndex,nombre) => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <AutoComplete 
      style={{ width: 188, marginBottom: 8, display: 'block' }}
      options={this.getAutocomplete(dataIndex)}
      filterOption={(inputValue,option)=>option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
      onChange={(value)=>{setSelectedKeys(value ? [value] : [])}}
      value={selectedKeys[0]}
      >
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Buscar ${nombre}`}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        />
      </AutoComplete>
      <Space>
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90 }}
        >
          Buscar
        </Button>
        <Button onClick={() =>{setSelectedKeys([]); this.handleReset(clearFilters)}} size="small" style={{ width: 90 }}>
          Resetear
        </Button>

      </Space>

    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    dataIndex!="author"?
     (record[dataIndex]
      ? record[dataIndex].toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())
      : ''):
      (record[dataIndex]? record[dataIndex].some(auth=>auth['name'].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())):'')
 ,
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select(), 100);
    }
  },
  render: (text,record,index) =>

     this.state.searchedColumn === dataIndex ? (
       dataIndex !="author"?
      (<div style={{fontSize:'large' }}>
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text ? text.toString() : ''}
      />
      </div>):
      record[dataIndex].map(auth=>
      (<div style={{fontSize:'large' }}>
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={auth['name'] ? auth['name'] : ''}
      />
      </div>))
    ) : (
      <div style={{fontSize:'large' }}>
        {(dataIndex=="author" && <ol>{record.author.map((a,idx)=>{return <li>{a.name} </li>})}</ol> )
        || (  <div>{text}</div>)  }
      </div>
    ),
});
  getColumnSearchProps = (dataIndex,name) => dataIndex!='edit' && ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => ( dataIndex!='edit' &&
          <div style={{ padding: 8 }}>
            <AutoComplete 
            style={{ width: 188, marginBottom: 8, display: 'block' }}
            options={this.getAutocomplete(dataIndex)}
            filterOption={(inputValue,option)=>option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
            onChange={(value)=>{setSelectedKeys(value ? [value] : [])}}
            value={selectedKeys[0]}

            >
             <Input
               ref={node => {
                this.searchInput = node;
              }}
              placeholder={`Buscar ${name}`}
              onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            />
            </AutoComplete>
            <Space>
              <Button
                type="primary"
                onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Buscar
              </Button>
              <Button onClick={() => this.handleReset(clearFilters)} size="small" type="reset" style={{ width: 90 }}>
                Resetear
              </Button>
    
            </Space>
          </div>
        ),
        filterIcon: filtered =>dataIndex!='edit' && <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
          record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
        onFilterDropdownVisibleChange: visible => {
          if (visible && dataIndex!= 'edit') {
            setTimeout(() => this.searchInput.select(), 100);
          }
        },
        render: (text,record,index) =>
          this.state.searchedColumn === dataIndex ? (
            <div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
            </div>
          ) : (
            <div  style={{fontSize:'large' }}>
            {(dataIndex=='edit' && <a onClick={()=>{this.onClickEditJury(record)}}> <EditOutlined /></a>)||
            <a onClick = {()=>this.onClickJury(record)} >  {text} </a>}
            </div>
          ),
      });
    
      handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
          searchText: selectedKeys[0],
          searchedColumn: dataIndex,
        });
      };
    
      handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
      };
      createJury =() => {
        this.setState({ create:true });
      };
      closeCreateJury =() => {
        this.setState({ create:false });
      };
     
  render() {
    const { Content } = Layout;
    const Moment = require('moment');
    const columns = [
      {
        title: <div style={{fontWeight:'bold', fontSize:'large' }}>Nombre</div>,
        dataIndex: 'full_name',
        key: 'full_name',
        sorter: (a, b) => a.full_name.localeCompare(b.full_name),
        sortDirections:['ascend', 'descend', 'ascend'],
        ...this.getColumnSearchProps('full_name','nombre'),
        responsive: ['sm'] 
      },
      {
        title: <div style={{fontWeight:'bold', fontSize:'large' }}>Usuario</div>,
        dataIndex: 'name',
        key: 'name',
        sorter: (a, b) => a.name.localeCompare(b.name),
        sortDirections:['ascend', 'descend', 'ascend'],
        ...this.getColumnSearchProps('name','usuario'),
        responsive: ['sm'] 
      },
      {
        title: <div style={{  position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignElements:'center',fontWeight:'bold', fontSize:'large'}}>Editar</div>,
        dataIndex: 'edit',
        key: 'edit',
        
        width:'90px',
        render: (text,record) =>(
                    <div  style={{     position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignElements:'center', fontSize:'large' }}>
                    <a onClick={()=>{this.onClickEditJury(record)}}> <EditOutlined /></a>
                    </div>
        ),
        sortDirections:['ascend', 'descend', 'ascend'],
        responsive: ['sm'] 
      },
      {
        title: <div style={{  position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignElements:'center',fontWeight:'bold', fontSize:'large'}}>Eliminar</div>,
        dataIndex: 'delete',
        key: 'delete',
        
        width:'90px',
        render: (text,record) =>(
                    <div  style={{     position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignElements:'center', fontSize:'large' }}>
                        <Popconfirm
                        title="Está seguro que desear eliminar este jurado?"
                        onConfirm={()=>{this.onClickDeleteJury(record)}}
                        okText="Si"
                        cancelText="No"
                      >
                        <a> <DeleteOutlined /></a>
                      </Popconfirm>,
                    
                    </div>
        ),
        sortDirections:['ascend', 'descend', 'ascend'],
        responsive: ['sm'] 
      },
    ];
    const formItemLayout = {
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 8,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
    };
    const validateMessages =  {

      required: '${label} es requerido!',
      types: {
        email: '${label} no es un email válido!',
        number: '${label} no es un número válido!',
      },
      number: {
        range: '${label} must be between ${min} and ${max}',
      },
    }

    const customRequest = (form) => {
      const data= new FormData()
      form['telefono'] = form['telefono'] == undefined ? '': '+' + form['telefono']
        
      if (form['direcc_personal'] == undefined)
        form['direcc_personal'] = ''
        
      if (form['email'] == undefined)
        form['email'] = ''
      for ( var key in form ) {
        if(key =='autores'){
          data.append(key,JSON.stringify( form[key]));
        }
        else{
          if(key != 'genero')
            data.append(key, form[key]);
        }
      }
      data.append('premio',1)
      var gen = form['genero']== undefined ? 1:form['genero']
      data.append('genero',gen)
        this.setState({isBussy:true},()=>axios.post(IP + 'api/musica/jurado/register',data, {
              headers: {
              "Authorization": localStorage.getItem("Authorization") ,
              "Accept": "application/json",
              "Content-Type": "application/json"
              }
          }).then((res) => {
            if (res.status == 200){
              this.setState({isBussy:false})
              Modal.success({
                content: 'Jurado registrado',
                onOk:()=> window.location.reload(false)
              });
            } ;
          }).catch((err) => {
            var errorsMessage = err.response.data.join(';')
            this.setState({isBussy:false})
            notification.error({
              message:'Error',
              description:errorsMessage ,
            });
          }))
    }
    return (

      <div className="page-container">
      <div className = "content-wrap">
      <ConfigProvider locale={es_ES}>
      <Layout style={{backgroundColor:'white'}}>
      <AdminMenu defaultSelectedKey = {"jury"}/>
            
            <Content>
                  <Row  align="middle" justify="center">
                    <Col span={12}>
                      <Table 
                      loading={this.state.isBusy}
                      columns={columns}
                      bordered 
                      dataSource= {this.state.plays}
                      pagination={{ position: ["bottomCenter"],}}
                      tableLayout='fixed'
                      style={{ whiteSpace: 'normal'}}
                      size="medium"
                      footer={()=> <Button onClick={this.createJury}style={{alignItems:'end', width:'100%'}}>Añadir jurado</Button>}
                      />
                    </Col>
                  </Row>
                {
                    this.state.showArticle && 
                    <Modal 
                    closable = {false}
                        title={ this.state.record.title}
                        visible={this.state.showArticle} 
                        onCancel={this.hideModal}
                        footer={[
                            <Button key="back" onClick={this.hideModal}>
                            Regresar
                            </Button>,
                        ]}
                        >
                        <p><UserOutlined /> Nombre completo: {this.state.record.full_name}</p>
                        <p><UserOutlined /> Usuario: {this.state.record.name}</p>
                        <p><MailOutlined /> Email: {this.state.record.email}</p>
                        <p><PhoneOutlined /> Teléfono: {this.state.record.phone}</p>
                        <p><GlobalOutlined /> País: {this.state.record.country}</p>
                        <p><EnvironmentOutlined /> Dirección: {this.state.record.address}</p>
                        <p><IdcardOutlined /> Ficha: {this.state.record.ficha}</p>
                    </Modal>
                    }
                    { this.state.edit && <Modal 
                          closable = {false}
                          title={ this.state.record.title}
                          visible={this.state.edit} 
                          footer={[
                            <Button key="save" onClick={()=>this.onClickSave()}>
                            Guardar
                            </Button>,
                              <Button key="back" onClick={this.hideEdit}>
                              Regresar
                              </Button>,
                               
                          ]}
                          >
                         <p><UserOutlined /> Nombre completo:<Input defaultValue= {this.state.record.full_name} id="fullNameInput" /> </p>
                         <p><UserOutlined /> Usuario:<Input defaultValue= {this.state.record.name} id="nameInput" /> </p>
                         <p><UserOutlined /> Cambiar contraseña:<Input.Password id="password" /> </p>
                        <p><MailOutlined /> Email:<Input defaultValue= {this.state.record.email} id="emailInput" /></p>
                        <p><PhoneOutlined /> Teléfono: <Input defaultValue= {this.state.record.phone} id="phoneInput" /> </p>
                        <p><GlobalOutlined /> País:<br/> <Select style={{width:'100%'}} showSearch defaultValue={this.state.record.country} onChange={(value)=>this.onChangeSelect(value)} >
                                  {countries["countries"].sort((a,b)=>a["name_es"].localeCompare(b["name_es"])).map((obj)=>{
                                    return <Option key={obj["name_es"]} value={obj["name_es"]}>{obj["name_es"]}</Option>
                                })}
                                    
                                  </Select> </p>
                        <p><EnvironmentOutlined /> Dirección: <Input defaultValue= {this.state.record.address} id="addressInput" /></p>
                        <p><IdcardOutlined /> Ficha: <Input defaultValue= {this.state.record.ficha} id="fichaInput" /></p>
                      </Modal>}
                      
                      { this.state.create && 
                      
                      <Modal 
                          closable = {false}
                          title={"Añadir jurado"}
                          visible={this.state.create} 
                          onCancel={this.closeCreateJury}
                          footer={[
                              <Button key="back" onClick={this.closeCreateJury}>
                              Regresar
                              </Button>,
                          ]}
                      >
                         
                                    
                          <Form {...formItemLayout} id='regForm' name="nest-messages" onFinish={customRequest} validateMessages={validateMessages} layout = 'horizontal' initialValues={{autores: [""]}}>
                          
                          <Row  justify="center" align="middle" >
                            <Col xs={{span:24, offset:0 }}sm={{span:24, offset:0 }}>
                              <Row  justify="center" align="middle" >
                                <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                    <Form.Item name={['nombre_completo']} fieldKey={['first']} label="Nombre completo" rules={[{ required: true }]}>
                                      <Input style={{width:'80%'}}/>
                                    </Form.Item>
                                </Col>
                              </Row>


                              <Row  justify="center" align="middle" >
                                <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                  <Form.Item name={['username']} fieldKey={['first']} label="Nombre de usuario" rules={[{ required: true }]}>
                                    <Input style={{width:'80%'}}/>
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row  justify="center" align="middle" >
                                <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                  <Form.Item name={['password']} fieldKey={['first']} label="Contraseña" rules={[{ required: true }]}>
                                    <Input style={{width:'80%'}}/>
                                  </Form.Item>
                                </Col>
                              </Row>
                                          
                              <Row  justify="center" align="middle" >
                                <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                    <Form.Item  name={['pais']} label="País" fieldKey={[ 's']} rules={[{ required: true }]}>
                                      <Select style={{width:'80%'}} showSearch className="my-select">
                                        {countries["countries"].sort((a,b)=>a["name_es"].localeCompare(b["name_es"])).map((obj)=>{
                                          return <Option value={obj["code"]}>{obj["name_es"]}</Option>
                                      })}
                                        </Select>
                                    </Form.Item>
                                  </Col>
                              </Row>
                              <Row  justify="center" align="middle" >
                               <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                  <Form.Item  name={[ 'email']} label="Correo electrónico" rules={[{ type: 'email',  required: false }]}>
                                    <Input style={{width:'80%'}} />
                                  </Form.Item>
                                </Col>
                              </Row>
                                            
                                            <Row  justify="center" align="middle" >
                                        <Col xs={{span:24, offset:2}}sm={{span:24, offset:0 }}>
                                            <Form.Item  name={[ 'telefono']} label="Teléfono" rules={[{ required: false }]}>
                                                  <PhoneInput
                                                  localization={es}
                                              country={'cu'}
                                              enableSearch={true}
                                              searchPlaceholder="Buscar"
                                              value={this.state.phone}
                                              autoFocus= {true}
                                              onChange={phone => this.setState({ phone })}
                                              placeholder ={"Número de teléfono"}
                                            />
                                            </Form.Item>
                                            </Col>
                                            </Row>
                                            
                                            <Row  justify="center" align="middle" >
                                              <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                                <Form.Item name={[ 'direcc_personal']} label="Dirección postal"rules={[{ required: false }]}>
                                                  <Input style={{width:'80%'}}/>
                                                </Form.Item>
                                              </Col>
                                            </Row>
                                            
                                            <Row  justify="center" align="middle" >
                                              <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                                <Form.Item  name={[ 'ficha']} label="Ficha bio-bibliográfica">
                                                  <Input.TextArea  placeholder='Máximo 500 caracteres' style={{width:'80%'}} />
                                                </Form.Item>

                                              </Col>
                                            </Row>
                            </Col>
                          </Row>
                        <Row  justify="center" align="middle" >
                          <Col xs={{span:22, offset:2 }}sm={{span:16, offset:8 }}>
                            <Form.Item  >
                                <Button icon={<CheckOutlined/>} type="primary" htmlType="submit" size='small' >
                                  Registrar
                                </Button>
                            </Form.Item>
                          </Col>
                        </Row>
                          </Form>
                      </Modal>}
            </Content>
          </Layout>
        </ConfigProvider>
    </div>
    <Foot admin={true}/>
    </div>
    );
  }
}
export default ConcList;